import { AIONZ_DIALOG_DATA, AionzDialogContent, AionzDialogRef, AionzDialogTitle, HeaderBottomSheetComponent } from '@aionzdev/design-system';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CustomerTradingFocDialogData } from '../../../interfaces/customer-trading-foc-dialog-data';

@Component({
  selector: 'aionz-costumers-trading-foc-list',
  standalone: true,
  imports: [MatButtonModule, HeaderBottomSheetComponent, AionzDialogContent, AionzDialogTitle],
  templateUrl: './costumers-trading-foc-list.component.html',
  styleUrl: './costumers-trading-foc-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CostumersTradingFocListComponent {
  protected readonly data = inject<CustomerTradingFocDialogData>(AIONZ_DIALOG_DATA);
  private readonly _dialogRef = inject(AionzDialogRef<CostumersTradingFocListComponent>);

  protected handleClose(): void {
    this._dialogRef.close();
  }

  protected handleViewFoc(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
